var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',[_c('Headline',{attrs:{"size":1}},[_vm._v("Seite nicht gefunden")]),_c('t-button',{attrs:{"type":"link","action":_vm.back}},[_vm._v("Zurück")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }